import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {Observable} from "rxjs";
import {ServiceAccountService} from "./service-account.service";
import {handleErrors} from "../misc/handle-errors.decorator";

export interface UpdateTokenDialogModel {
  message: string;
  accountId: string; // This is not really necessary, since the actual Update is not done on the dialog
}

@Component({
  templateUrl: "./dialog-update-token.template.pug",
  providers: [
    ServiceAccountService,
  ],
})
export class UpdateTokenDialogComponent
  extends DialogComponent<UpdateTokenDialogModel, any> implements UpdateTokenDialogModel {
  message: string;
  accountId: string;
  public error: Error;
  public tokenKey: string;
  public tokenSecret: string;

  static showUpdateTokenDialogModal(dialogService: DialogService, inputs: UpdateTokenDialogModel):
  Observable<any> {
    return dialogService.addDialog(UpdateTokenDialogComponent, inputs, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  cancel(): void {
    this.result = {success: false};
    this.close();
  }

  @handleErrors()
  async changeToken(): Promise<void> {
    const {data, authenticationMechanism} =
      await this.serviceAccountService.updateOutgoingToken(this.accountId, this.tokenKey, this.tokenSecret);
    this.result = {success: true, data, authenticationMechanism};
    this.close();
  }

  constructor(
    public dialogService: DialogService,
    private serviceAccountService: ServiceAccountService,
  ) {
    super(dialogService);
  }
}
